const androidBridge = {
  // 请求参数
  async getQueryParam() {

  },

  async canIUse() {

  },

  async isVerBigEqNow() {

  },

  // 获取当前用户信息
  async getUserInfo() {

  },
  // 获取当前国家
  async getLoc() {

  },

  // 客户端相关信息【版本号等】
  async getClientInfo() {

  },

  async analyse() {

  },

  async jumpToProfile() {

  },

  async jumpToPay() {

  },

  async showPayDialog() {

  },

  async onBackPress() {

  },

  async jumpToParty() {

  },


  async backToPrePage() {

  },


  async signOut() {

  },

  /**
     * 隐藏返回按钮，阻止测滑
     */
  async stopBackBehavior() {

  },


  previewEffect() {

  },
  jump2Activity (){},
  jump2ActivityByRoute(){},
  showToast() {},
  getStatusBarHeight() {},
}
export default androidBridge
